import {ErrorMessages} from 'constants/Errors';

import {call, put} from 'redux-saga/effects';
import {unassignPubEditor} from 'services/pubs';
import {setSuccessAC} from 'store/app/appSlice';
import {handleError} from 'store/app/error/saga';
import {getSingleEditorACS} from 'store/singlePageEditor/requestAC';

import {removeUnassignedPubEditorAC} from '../pubPageSlice';
import {unassignPubEditorACS} from '../requests';

export function* deleteAssignedPubEditorSaga(action: ReturnType<typeof unassignPubEditorACS>) {
  const {pubId, editorId, userId} = action.payload;

  try {
    yield call(unassignPubEditor, pubId, editorId);
    yield put(removeUnassignedPubEditorAC(editorId));
    yield put(setSuccessAC('Page editor unassigned successfully'));

    if (userId) yield put(getSingleEditorACS(userId));
  } catch (error) {
    yield call(handleError, error, ErrorMessages.UNASSIGN_EDITOR);
  }
}
